<template>
  <footer class="clearfix mt4 footer">
    <div class="col col-12">
      <div class="clearfix">
        <div class="max-width-4 mx-auto">
          <div class="clearfix mt2 mb2">
            <div class="md-col-8 sm-col-12 mx-auto center">

              <h3 class="sub-headline mb0">Psychologische Praxis</h3>
              <h4 class="sub-headline mt1 mb0">Mag. Harald Parrainer</h4>
              <p class="paragraph mt1">Klinischer Psychologe. Gesundheitspsychologe.</p>

              <ul class="list-style-none list-reset">
                <li class="inline-block p0">
                  <router-link :to="{ name: 'Legal' }" title="Impressum - Psychologische Praxis Mag. Harald Parrainer"
                               class="text-decoration-none">Impressum
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'app-footer'
  }
</script>

<style lang="scss">
@import "../assets/scss/variables";

.footer {
  background-color: $primary-link-color;

  .sub-headline {
    text-transform: uppercase;
    font-family: $headline-font;
    color: white;
  }

  .paragraph {
    color: white;
    font-family: $headline-font;
    padding-bottom: 1.3rem;
    box-sizing: border-box;

    border-bottom: 1px solid white;
  }

  ul {
    li {
      font-family: $font-stack;
      font-size: 0.8rem;
      line-height: 1rem;
      color: white;
      padding-left: 0.5rem;
      padding-right: 0.5rem;

      .circle {
        color: white;
        height: 5px;
        width: 5px;
        vertical-align: middle;
        background-color: white;
        border-radius: 50%;
        display: inline-block;
      }

      a {
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue